/** Bank / demat account helpers for admin order placement. */

export function getAccountUuid(account) {
  if (!account || typeof account !== 'object') return '';
  const id = account.uuid ?? account.id ?? '';
  return String(id || '').trim();
}

export function getPrimaryOrFirst(items) {
  if (!Array.isArray(items) || items.length === 0) return null;
  return items.find((item) => item?.is_primary) || items[0];
}

export function pickDefaultAccountUuid(accounts) {
  return getAccountUuid(getPrimaryOrFirst(accounts));
}

export function normalizeDocumentUrl(url) {
  if (!url) return '';
  const str = String(url);
  const duplicatedHostMatch = str.match(/^(https?:\/\/[^\/]+)\/\1(\/.*)$/);
  if (duplicatedHostMatch) {
    return `${duplicatedHostMatch[1]}${duplicatedHostMatch[2]}`;
  }
  return str;
}
